// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"101":"12606a21","137":"040a6fb6","434":"ec61df4b"}[chunkId] + ".chunk.css";
};